import { Statistics } from "@app/core/statistics/domain/model/statistics";
import { Observable } from "rxjs";
import { StatisticsSearchCriteria } from "@app/core/statistics/domain/statistics-search-criteria";

export abstract class StatisticsRepo {
  /**
   * Get the general statistics of the user.
   * @param token
   * @param statisticsSearchCriteria
   */
  abstract getAggregate(
    statisticsSearchCriteria: StatisticsSearchCriteria,
    token: string
  ): Observable<Statistics>;

  /**
   *
   * @param limit Limit of response matches.
   * @param token
   */
  abstract getList(limit: number, token: string): Observable<Statistics>;
}
